// ./Components/Navbar.js
// Version 3 of the navbar because react-bootstrap has had some odd issues and this one will be in Bootstrap 4.3.1 and styled by the css file and not react-bootstrap
// import React, { Component } from "react";
import React from "react";
import UserContext from "../../UserDataContext";
import "./Navbar.css";
import PrimaryBtn from "../../SmallComponents/PrimaryBtn";
import ProfileModal from "../../Components/ProfileModal";
import NavNotifcations from "./Components/NavNotifcations";
import { FSCHistory } from "../ShipmentCard/Components";
// import LanguageSelect from "./Components/LanguageSelect";
import NavDropdown from "../NavDropdown/NavDropdown";

class Navbar extends React.Component {
  static contextType = UserContext;
  constructor() {
    super();
    this.handleChangeGeneric = this.handleChangeGeneric.bind(this);
    this.handleSubmitSearch = this.handleSubmitSearch.bind(this);
    this.handleClearSubmit = this.handleClearSubmit.bind(this);
    this.onHide = this.onHide.bind(this);
    this.modalOpen = this.modalOpen.bind(this);
    this.condRenderLogo = this.condRenderLogo.bind(this);
    this.condRenderCarrierInfo = this.condRenderCarrierInfo.bind(this);
    this.onEnterKeyPress = this.onEnterKeyPress.bind(this);
    this.handleChangeSearchTerm = this.handleChangeSearchTerm.bind(this);
    this.handleCarrierChange = this.handleCarrierChange.bind(this);

    this.state = {
      profileModalShow: false,
      searchTerm: "allnums",
      searchVal: "",
      searchPlaceHolderValue: "Search All Shipments",
      searchType: "text",
    };
  }

  onHide() {
    this.setState({ profileModalShow: false });
  }

  modalOpen() {
    this.setState({ profileModalShow: true });
  }

  handleChangeGeneric(event) {
    event.preventDefault();
    this.setState({ [event.target.name]: event.target.value }, () => {
      let requiredCharactersBeforeAutoSearch = 4;
      if (
        this.state.searchTerm === "allnums" &&
        this.state.searchVal.length > requiredCharactersBeforeAutoSearch
      ) {
        this.handleSubmitSearch();
      } else {
        this.props.clearSearchResults();
      }
    });
  }

  handleChangeSearchTerm(event) {
    event.preventDefault();
    this.setState({ searchVal: "" });
    if (event.target.value === "allnums") {
      this.setState({
        searchPlaceHolderValue: "Search All Shipments",
        searchType: "text",
        searchTerm: "allnums",
      });
    }
    if (event.target.value === "pudate") {
      this.setState({
        searchPlaceHolderValue: "YYYY-MM-DD",
        searchType: "date",
        searchTerm: "pudate",
      });
    }
    if (event.target.value === "deldate") {
      this.setState({
        searchPlaceHolderValue: "YYYY-MM-DD",
        searchType: "date",
        searchTerm: "deldate",
      });
    }
    if (event.target.value === "pucity") {
      this.setState({
        searchPlaceHolderValue: "New York",
        searchType: "text",
        searchTerm: "pucity",
      });
    }
    if (event.target.value === "delcity") {
      this.setState({
        searchPlaceHolderValue: "Los Angeles",
        searchType: "text",
        searchTerm: "delcity",
      });
    }
    if (event.target.value === "status") {
      this.setState({
        searchPlaceHolderValue: "DEL",
        searchType: "status",
        searchTerm: "status",
        searchVal: "DEL",
      });
    }
    if (event.target.value === "settledate") {
      this.setState({
        searchPlaceHolderValue: "YYYY-MM-DD",
        searchType: "date",
        searchTerm: "settledate",
      });
    }
  }

  handleSubmitSearch(event) {
    if (event) {
      event.preventDefault();
    }
    this.props.clearSearchResults();
    this.props.setSearchTerm(this.state.searchTerm);
    this.props.setSearchVal(this.state.searchVal);
  }

  handleClearSubmit(event) {
    event.preventDefault();
    if (this.state.searchType === "status") {
    } else {
      this.setState({ searchVal: "" });
    }
    this.props.clearSearchResults();
  }

  handleCarrierChange(event) {
    this.props.changeCarrier(event.target.value);
  }

  onEnterKeyPress(event) {
    if (event.which === 13) {
      this.handleSubmitSearch(event);
    }
  }

  refreshShipments() {
    this.props.refreshShipments();
  }

  componentDidUpdate(prevProps) {
    if (
      this.props.externalSearchVal &&
      this.props.externalSearchVal !== prevProps.externalSearchVal
    ) {
      this.setState({ searchVal: this.props.externalSearchVal });
    }
  }

  // Renders just the logo image — carrier info is a separate row via condRenderCarrierInfo()
  condRenderLogo() {
    let logo;
    if (this.props.userData2.length) {
      logo = this.props.userData2.length > 1
        ? localStorage.getItem("clientLogo")
        : this.props.userData2[0].clientLogo;
    } else {
      logo = "se-icon-310x310.png";
    }
    return (
      <div className="d-flex flex-fill align-items-center navLogoContainer">
        <img src={logo} alt="logo" height="40" style={{ maxWidth: '100%' }} />
      </div>
    );
  }

  // Renders the carrier select (multi) or carrier name (single) as a full-width row
  condRenderCarrierInfo() {
    if (!this.props.userData2.length) {
      return (
        <div className="navCarrierRow">
          <span className="navCarrierText">ShippersEdge TMS</span>
        </div>
      );
    }
    if (this.props.userData2.length > 1) {
      this.props.userData2.sort((a, b) => a.carrierId > b.carrierId ? 1 : -1);
      return (
        <div className="navCarrierRow">
          <select
            id="broker-select-options"
            className="form-control form-control-sm"
            onChange={this.handleCarrierChange}
            value={this.props.currentCarrierId}
          >
            {this.props.userData2.map((carrierCustomer) => (
              <option key={carrierCustomer.carrierId} value={carrierCustomer.carrierId}>
                {carrierCustomer.clientName} Carrier Portal -{" "}
                {carrierCustomer.userName} {carrierCustomer.carrierName}
              </option>
            ))}
          </select>
        </div>
      );
    }
    const { clientName, carrierName } = this.props.userData2[0];
    const userName = this.props.userData2[0].name;
    return (
      <div className="navCarrierRow">
        <span className="navCarrierText">
          {clientName} Carrier Portal - {userName} - {carrierName}
        </span>
      </div>
    );
  }

  render() {
    return (
      <nav className="nav fixed-top ">
        <div className="container">
          {/* Row 1: Logo (left/center) + Notifications + Profile + Language (right) */}
          <div className="d-flex align-items-center navRowTop">
            {this.condRenderLogo()}
            <div className="d-flex align-items-center flex-shrink-0">
              <NavNotifcations />
              <span className="mr-2"><NavDropdown /></span>
              <PrimaryBtn
                btnName="Profile"
                showHide="show"
                onClick={this.modalOpen}
              />
              <button
                className="btn btn-outline-secondary btn-sm d-md-none navMarginLeft"
                onClick={this.props.refreshShipments}
                disabled={this.props.refreshLoading}
                aria-label="Refresh shipments"
              >
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-arrow-clockwise" viewBox="0 0 16 16">
                  <path fillRule="evenodd" d="M8 3a5 5 0 1 0 4.546 2.914.5.5 0 0 1 .908-.417A6 6 0 1 1 8 2z"/>
                  <path d="M8 4.466V.534a.25.25 0 0 1 .41-.192l2.36 1.966c.12.1.12.284 0 .384L8.41 4.658A.25.25 0 0 1 8 4.466"/>
                </svg>
              </button>
              {localStorage.getItem("carrierClientId") === "alanwire" ? (
                <FSCHistory />
              ) : null}
              <ProfileModal
                show={this.state.profileModalShow}
                onHide={this.onHide}
              />
            </div>
            {/* <div className="d-flex align-items-center flex-shrink-0">
              {this.context?.clientCode === "momcorp" || this.context?.clientCode === "acmebumn" ? (
                <LanguageSelect language={this.props.language} setLanguage={this.props.setLanguage} />
              ) : null}
            </div> */}
          </div>

          {/* Row 2: Carrier select or carrier name — full width */}
          {this.condRenderCarrierInfo()}

          {/* Row 3: Search controls */}
          <div className="navRowBottom d-flex align-items-center">
            <div className="form-group d-flex justify-content-end">
              <select
                className="form-control form-control-sm"
                disabled={!this.props.searchEnable}
                as="select"
                size="sm"
                name="searchTerm"
                onChange={this.handleChangeSearchTerm}
              >
                <option defaultValue="allnums" value="allnums">
                  All Reference Numbers
                </option>
                <option value="pudate">Pick Up Date</option>
                <option value="deldate">Delivered Date</option>
                <option value="pucity">Pick Up City</option>
                <option value="delcity">Delivered City</option>
                <option value="status">Status</option>
                <option value="settledate">Settlement Date</option>
              </select>
            </div>
            <div className="form-group d-flex justify-content-end">
              {this.state.searchType === "text" ? (
                <input
                  className="form-control form-control-sm navMarginLeft mr-1"
                  disabled={!this.props.searchEnable}
                  size="sm"
                  type="text"
                  placeholder={this.state.searchPlaceHolderValue}
                  name="searchVal"
                  value={this.state.searchVal}
                  onChange={this.handleChangeGeneric}
                  onKeyPress={this.onEnterKeyPress}
                />
              ) : null}
              {this.state.searchType === "date" ? (
                <input
                  className="form-control form-control-sm navMarginLeft mr-1"
                  disabled={!this.props.searchEnable}
                  size="sm"
                  type="date"
                  placeholder={this.state.searchPlaceHolderValue}
                  name="searchVal"
                  value={this.state.searchVal}
                  onChange={this.handleChangeGeneric}
                  onKeyPress={this.onEnterKeyPress}
                />
              ) : null}
              {this.state.searchType === "status" ? (
                <select
                  className="form-control form-control-sm navMarginLeft mr-1"
                  disabled={!this.props.searchEnable}
                  size="sm"
                  type="date"
                  placeholder={this.state.searchPlaceHolderValue}
                  name="searchVal"
                  value={this.state.searchVal}
                  onChange={this.handleChangeGeneric}
                  onKeyPress={this.onEnterKeyPress}
                >
                  <option value="DEL">Delivered</option>
                  <option value="DSP">Dispatched</option>
                  <option value="IT">In Transit</option>
                  <option value="OFD">Out For Delivery</option>
                  <option value="NEED-REVIEW">Need Review</option>
                </select>
              ) : null}
            </div>
            <div className="form-group d-flex justify-content-end">
              <PrimaryBtn
                showHide="show"
                extraclassName="navMarginLeft"
                btnName="Search"
                disabled={!this.props.searchEnable}
                onClick={this.handleSubmitSearch}
              />
              <PrimaryBtn
                showHide="show"
                extraclassName="navMarginLeft"
                btnName="&nbsp;Clear&nbsp;"
                disabled={!this.props.searchEnable}
                onClick={this.handleClearSubmit}
              />

              <br />
            </div>
          </div>
        </div>
      </nav>
    );
  }
}

export default Navbar;
